import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';
import { AlertService } from '../../../_shared/services/alert.service';
import { UtilService } from '../../../_shared/services/util.service';

import { WhatToBring } from '../../shared/what-to-bring.model';
import { WhatToBringService } from '../../shared/what-to-bring.service';

@Component({
  selector: 'app-what-to-bring-translation-modal',
  templateUrl: './what-to-bring-translation-modal.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class WhatToBringTranslationModalComponent {
  constructor(
    private alertService: AlertService,
    private utilService: UtilService,
    private whatToBringService: WhatToBringService,
    private formBuilder: FormBuilder,
    private ref: MatDialogRef<WhatToBringTranslationModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {
    // use it onInit ??
    this.getWhatToBring();
  }

  whatToBring: WhatToBring = null;
  whatToBringCopy = null;

  modalTitle = this.data.title;
  whatToBringId = this.data.obj.id;
  language = this.data.params.language;

  form: FormGroup;

  serverErrors = [];
  sendingForm = false;

  // Referenced from app-item-detail-form-actions
  onSavedWhatToBringTranslation() {
    if (this.form.invalid) {
      this.serverErrors = [];

      return;
    }

    const formData = this.form.value;

    const fields = ['name', 'description'];

    if (!fields.some((field) => formData[field] !== this.whatToBringCopy[field])) {
      this.close();
      return;
    }

    this.sendingForm = true;

    this.whatToBringService
      .saveWhatToBring(this.whatToBring.id, formData, this.language.lang)
      .subscribe({
        next: (response) => {
          this.alertService.open('TRANSLATION_SAVED');

          this.sendingForm = false;

          this.ref.close(response);
        },
        error: (response) => {
          this.serverErrors = this.utilService.setFormServerErrors(response.error.errors);

          this.sendingForm = false;
        },
      });
  }

  onCanceled() {
    this.close();
  }

  close() {
    this.ref.close();
  }

  private getWhatToBring() {
    let params = {
      get: 'translate',
      lang: this.language.lang,
    };

    this.whatToBringService.getWhatToBring(this.whatToBringId, params).subscribe((whatToBring) => {
      this.whatToBring = whatToBring;
      this.whatToBringCopy = { ...this.whatToBring };

      this.setWhatToBringTranslationForm();

      this.form.patchValue(this.whatToBring);
    });
  }

  private setWhatToBringTranslationForm() {
    this.form = this.formBuilder.group({
      name: [
        '',
        {
          validators: [
            Validators.required,
            // Validators.maxLength(100),
            // Validators.pattern(this.utilService.selectInputPattern('text')),
          ],
          updateOn: 'blur',
        },
      ],
      description: '',
    });
  }
}

/*

const formData = this.utilService.deleteNullFields(fields, this.form.value);

this.form = this.formBuilder.group({
      name: [
        this.whatToBring.name,
        {
          validators: [
            Validators.required,
            // Validators.maxLength(100),
            // Validators.pattern(this.utilService.selectInputPattern('text')),
          ],
          updateOn: 'blur',
        },
      ],
      description: [this.whatToBring.description],
    });

*/
